import { Flex, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { spacing } from '../../theming';
import { formatLocal } from '../../utils/vinExtraction';
import { cardTitleStyle, mutedSmallStyle } from './vinExtractionStyles';

/** Kind and number (+ "Latest" on the newest attempt) on the left, the attempt's local time on the right. */
const AttemptHeader = ({ attempt, latest }) => {
    const { t, i18n } = useTranslation('vinExtraction');

    return (
        <Flex justify="space-between" align="center" gap={spacing[1]}>
            <Flex align="center" gap={spacing[1]}>
                <span style={cardTitleStyle}>
                    {t(`drawer.attempt.kind.${attempt.kind}`, { number: attempt.attemptNumber })}
                </span>
                {latest && (
                    <Tag color="blue" bordered={false}>
                        {t('drawer.attempt.latest')}
                    </Tag>
                )}
            </Flex>
            <span style={mutedSmallStyle}>{formatLocal(attempt.createdAt, 'DD MMM, HH:mm', i18n.language)}</span>
        </Flex>
    );
};

export default AttemptHeader;
